import { useEffect } from "react";

/**
 *  This hook must be used in case when show scroll is required because
 *  the page without scroll cause UI issues.
 */
export const useAddScrollToBody = () => {
  const body = document.body;

  useEffect(() => {
    return () => {
      body.style.overflowY = "auto";
      body.style.overflowX = "auto";
    };
  }, []);

  const addScroll = () => {
    body.style.overflowY = "scroll";
    body.style.overflowX = "hidden";
  };

  const restoreScroll = () => {
    body.style.overflowY = "auto";
    body.style.overflowX = "auto";
  };

  return { addScroll, restoreScroll };
};
